import { NgModule } from '@angular/core';
import { SvgSymbolsComponent } from './svg-symbols.component';
import { SymbolAvatarsComponent } from './symbol-avatars/symbol-avatars.component';
import { SymbolIconsComponent } from './symbol-icons/symbol-icons.component';

@NgModule({
  declarations: [
    SymbolAvatarsComponent,
    SymbolIconsComponent,
    SvgSymbolsComponent
  ],
  exports: [
    SymbolAvatarsComponent,
    SymbolIconsComponent,
    SvgSymbolsComponent
  ]
})

export class SvgSymbolsModule {}
